// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "styles" + "." + "93d4a4a0b0fe0ff4fe3e" + ".css";
};